
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1.454 .995)","stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.948 21.323H5.694v-8.712c0-.507.41-.917.917-.917h6.42c.506 0 .917.41.917.917v8.712z"}}),_c('path',{attrs:{"d":"M2.935 21.322H1.559V4.815c0-.76.616-1.376 1.376-1.376h4.127c.76 0 1.375.616 1.375 1.376v4.127H7.062m6.88 12.38h5.503m-17.883 0H.186M8.44 6.19H5.689m8.253 8.254h-2.063m-3.442 6.878h2.751v-2.751a1.375 1.375 0 10-2.751 0v2.751z"}}),_c('circle',{attrs:{"cx":"16.006","cy":"5.503","r":"2.063"}}),_c('path',{attrs:{"d":"M16.006.688v.688m-4.169 1.719l.595.344m-.595 4.471l.595-.344m3.574 2.751v-.688m4.17-1.719l-.596-.344m.596-4.471l-.596.344"}})])])
          )
        }
      }
    